import React, { useContext } from "react";
import Grid from "@material-ui/core/Grid";
import Hidden from '@material-ui/core/Hidden';
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";

import SurveyQuestionContext from "../../../context/surveyquestion-context";
import { SnapShotSurveyData } from "../../../utils/services/cache/ClientCache";
import useStyles from "../../../styles/components/survey/stylesSurvey";
import { Coin, Buttons } from "../../shared/component";
import { getIconSurvey } from "../../../utils/helpers/icon/iconHelper";
import SurveyQuestionContainer from "./SurveyQuestionContainer";


const SurveyQuestionHolder = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const { surveyQuestionContext } = useContext(SurveyQuestionContext);

    const surveyName = SnapShotSurveyData.getSnapshotSurveyName();
    const snapshotReward = SnapShotSurveyData.getSnapshotRewardPoint();

    const handleClick = (e) => setOpen(true);

    return (
        <>
            {surveyQuestionContext && (
                <Grid item xs={12} classes={{ root: classes.rootGridContainer }}>
                    <Typography
                        variant="h6"
                        gutterBottom
                        classes={{ root: classes.rootNote }}
                    >
                        Please complete all the questions
                    </Typography>
                    {open ? (
                        <SurveyQuestionContainer />
                    ) : (
                            <Accordion
                                expanded={true}
                                className={clsx(
                                    classes.rootAccordion,
                                    classes.rootAccordionSurveyDetail
                                )}
                            >
                                <AccordionSummary
                                    classes={{ content: classes.contentAccordionSummary }}
                                >
                                    <img
                                        src={getIconSurvey().img_survey_question}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            margin: "0",
                                            objectFit: "cover",
                                        }}
                                    />
                                    <br />
                                    <br />
                                    <Grid container justify="space-between" alignItems="center">
                                        <Typography variant="h6" className={clsx(classes.rootNote, classes.rootTypographyNote)}>
                                            {surveyName}
                                        </Typography>
                                        <Hidden smDown>
                                            <Coin coin={snapshotReward} size="medium" />
                                        </Hidden>
                                        <Hidden mdUp>
                                            <Coin coin={snapshotReward} size="small" />
                                        </Hidden>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container justify="center" alignItems="center">
                                        <Buttons
                                            text="Begin"
                                            customClass="customButton"
                                            onClick={handleClick}
                                        ></Buttons>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        )}
                </Grid>
            )}
        </>
    );
};

export default SurveyQuestionHolder;